<app-loading-indicator [loading]="loading"></app-loading-indicator>

  <div class="p-grid">
    <div class="p-col-12">
      <label for="name">{{'COMPANY_NAME' | translate}}</label>
      <input id="name" name="name" type="text" pInputText [(ngModel)]="item.name">
      <small class="p-error">{{ errors['name'] }}</small>
    </div>
    <div class="p-col-6">
      <label for="phoneNumber">{{'PHONE_NUMBER' | translate}}</label>
      <input id="phoneNumber" name="phoneNumber" type="text" pInputText [(ngModel)]="item.phoneNumber">
      <small class="p-error">{{ errors['phoneNumber'] }}</small>
    </div>
    <div class="p-col-6">
      <label for="email2">{{'EMAIL' | translate}}</label>
      <input id="email2" type="text" name="email" pInputText [(ngModel)]="item.email">
      <small class="p-error">{{ errors['email'] }}</small>
    </div>
    <div class="p-col-6">
      <label for="taxAgency">{{'TAX_AGENCY' | translate}}</label>
      <input id="taxAgency" name="taxAgency" type="text" pInputText [(ngModel)]="item.taxAgency">
      <small class="p-error">{{ errors['taxAgency'] }}</small>
    </div>
    <div class="p-col-6">
      <label for="taxAgencyNumber">{{'TAX_AGENCY_NUMBER' | translate}}</label>
      <input id="taxAgencyNumber" name="taxAgencyNumber" type="text" pInputText [(ngModel)]="item.taxAgencyNumber">
      <small class="p-error">{{ errors['taxAgencyNumber'] }}</small>
    </div>
    <div class="p-col-6">
      <label for="contactNumber">{{'CONTACT_NUMBER' | translate}}</label>
      <input id="contactNumber" name="contactNumber" type="text" pInputText [(ngModel)]="item.contactNumber">
      <small class="p-error">{{ errors['contactNumber'] }}</small>
    </div>
    <div class="p-col-6">
      <label for="type">{{'CONTACT_TYPE' | translate}}</label>
      <p-dropdown
        [style]="{width: '100% !important'}"
        [options]="contactTypes" appendTo="body" (onChange)="this.item = $event.value"
        [ngModel]="item.type"  placeholder="select"
        optionLabel="name" optionValue="value">
      </p-dropdown>
      <small class="p-error">{{ errors['type'] }}</small>
    </div>
    <div class="p-col-12" *ngIf="new">
      <label for="street">{{'STREET' | translate}}</label>
      <input id="street" type="text" pInputText [(ngModel)]="address.street" name="street">
    </div>
    <div class="p-col-6" *ngIf="new">
      <label for="city">{{'CITY' | translate}}</label>
      <p-dropdown id="city" [options]="cities" appendTo="body" [(ngModel)]="address.city" optionLabel="name"  optionValue="@id" name="city" (onChange)="loadDistricts($event.value)"></p-dropdown>
      <small class="p-error">{{ errors['city'] }}</small>
    </div>
    <div class="p-col-6" *ngIf="new">
      <label for="district">{{'STATE' | translate}}</label>
      <p-dropdown id="district" [options]="districts" appendTo="body" [(ngModel)]="address.district" optionLabel="name"  optionValue="@id" name="district"></p-dropdown>
      <small class="p-error">{{ errors['district'] }}</small>
    </div>
  </div>
  <div class="p-fluid">
    <div class="p-field p-col-3 p-offset-4">
      <button pButton label="{{ 'SAVE' | translate}}" [icon]="submitted ? 'pi pi-spin pi-spinner' : 'pi pi-check'" [disabled]="this.submitted" (click)="save()"></button>
    </div>
  </div>
